<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content style="text-align: center">
  <mat-spinner [diameter]="48" [strokeWidth]="5" *ngIf="data.progressSpinner"></mat-spinner>
  <mat-icon class="material-icons mat-48" [ngStyle]="data.iconStyle" *ngIf="data.icon">{{data.icon}}</mat-icon>
  <div [innerHTML]="data.body" *ngIf="data.body"></div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="primary" [mat-dialog-close]="false" *ngIf="data.yesButton">Nein</button>
  <button mat-button color="primary" [mat-dialog-close]="true" *ngIf="data.noButton">Ja</button>
</mat-dialog-actions>
